import styled from 'styled-components';

import Link from '../Link';

export const LanguageItem = styled(Link)`
  color: var(--color-text-light);
  font-size: var(--font-size-sm);
  margin-right: 0.8rem;

  ${({ isActive }) =>
    isActive &&
    `
    font-weight: var(--font-weight-semibold);
  `}
`;

export const Wrapper = styled.div`
  margin-right: 1.2rem;
`;
